<template>
  <BaseMap class="dashboard__map"
           height="50rem"
           :geometry="projectGeometry"
           :isLoading="isLoading"
           :can-fullscreen="false"
           @feature:click="$goto('project.show', $event.uuid)"
  />
</template>

<script>
import BaseMap from './BaseMap'

export default {
  components: { BaseMap },
  data: () => ({
    projectGeometry: null,
    isLoading: false,
  }),
  computed: {},
  methods: {
    async loadProjects (page = 1) {
      this.isLoading = true
      try {
        const { data } = await axios.get(this.$route('api.projects.internal', {
          per_page: 100,
          srid: 4326,
          page,
        }))
        this.projectGeometry = data
      } catch (e) {
        console.error(e)
      }
      this.isLoading = false
    },
  },
  mounted () {
    this.loadProjects()
  },
}
</script>